import React from 'react';
import SVG from './SVG.jsx';

export default class ProductDescription extends React.PureComponent {
  constructor(props) {
    super();

    const descriptionTemp = document.createElement('div');
    descriptionTemp.innerHTML = props.description;
    const descriptionHeadings = descriptionTemp.querySelectorAll('h2');
    descriptionHeadings.forEach(heading => heading.insertAdjacentHTML('beforeend', '<span class="icon"><span class="plus"><svg class="svg-icon icon-plus" xmlns="http://www.w3.org/2000/svg"><use xlink:href="#reuse-plus"></use></svg></span><span class="minus"><svg class="svg-icon icon-minus" xmlns="http://www.w3.org/2000/svg"><use xlink:href="#reuse-minus"></use></svg></span></span>'));

    this.descriptionHtml = descriptionTemp.innerHTML;
    this.ref = React.createRef();
  }

  componentDidMount() {
    this.ref.current.querySelectorAll('h2').forEach(h2 => {
      h2.addEventListener('click', (e) => {
        e.currentTarget.classList.toggle('expanded');
      })
    })
  }

  render() {
    return <div ref={this.ref} className="product-description rte" dangerouslySetInnerHTML={{__html: this.descriptionHtml}}></div>
  }
}